import { createSlice } from '@reduxjs/toolkit';
import {
  fetchTransactions,
  fetchAdjustedPlanAmount,
  addAlbumshotCredits,
} from '../thunks/transactions';

const initialState = {
  transactions: [],
  advanced1AdjustedAmount: null,
  advanced12AdjustedAmount: null,
  fetching: false,
  fetchError: '',
  saving: false,
  saveError: '',
  pageNumber: 1,
  perPage: 20,
};

export const transactionsSlice = createSlice({
  name: 'transactions',
  initialState,
  reducers: {
    setTransactionsPageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },
  },
  extraReducers: {
    [fetchTransactions.pending]: (state) => {
      state.fetching = true;
    },
    [fetchTransactions.fulfilled]: (state, action) => {
      state.fetching = false;
      state.transactions = action.payload;
    },
    [fetchTransactions.rejected]: (state, action) => {
      state.fetching = false;
      state.fetchError = action.payload.error;
    },
    [fetchAdjustedPlanAmount.pending]: (state) => {
      state.fetching = true;
    },
    [fetchAdjustedPlanAmount.fulfilled]: (state, action) => {
      state.fetching = false;
      if (action.payload.planName === 'advanced-1') {
        state.advanced1AdjustedAmount = action.payload.response;
      }
      if (action.payload.planName === 'advanced-12') {
        state.advanced12AdjustedAmount = action.payload.response;
      }
    },
    [fetchAdjustedPlanAmount.rejected]: (state, action) => {
      state.fetching = false;
      state.fetchError = action.payload.error;
    },
    [addAlbumshotCredits.pending]: (state) => {
      state.saving = true;
    },
    [addAlbumshotCredits.fulfilled]: (state, action) => {
      state.saving = false;
    },
    [addAlbumshotCredits.rejected]: (state, action) => {
      state.saving = false;
      state.saveError = action.payload.error;
    },
  },
});

export const { setTransactionsPageNumber } = transactionsSlice.actions;
